export const API_ENDPOINTS = Object.freeze({
  fetchPermissions: '/sdadsds'
});
